module.exports = __webpack_public_path__ + "images/background/image/6-135f8928e176fd872b313156bbc96191.jpg";